import FeatherIcon from "feather-icons-react";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import download from "downloadjs";

import { Button } from "@components/base";
import { useExportEmissionFactorCsv } from "@api";
import { useUserStore } from "@store/user";

const ExportEmissionFactorsButton: FC = () => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const { exportEmissionFactorCsvAsync, isPendingExportEmissionFactorCsv } =
    useExportEmissionFactorCsv(user);

  const handleExportEmissionFactors = async (): Promise<void> => {
    const response = await exportEmissionFactorCsvAsync();
    const csvHeader =
      "factor,scope,unitAbbreviation,questionCodes,year,type,source,sourceDetail\n";

    const csvContent =
      csvHeader +
      response
        .map((ef) =>
          [
            ef.factor,
            ef.scope,
            ef.unitAbbreviation,
            `"${ef.questionCodes}"`,
            ef.year,
            ef.type,
            ef.source,
            ef.sourceDetail,
          ].join(","),
        )
        .join("\n");

    download(csvContent, `emission_factors.csv`, "text/csv");
  };

  return (
    <Button
      variant="outlined"
      size="small"
      onClick={handleExportEmissionFactors}
      startIcon={<FeatherIcon icon="upload" width="16" height="16" />}
      loading={isPendingExportEmissionFactorCsv}
    >
      {t("admin.emissionFactorsManagement.exportButton")}
    </Button>
  );
};

export default ExportEmissionFactorsButton;
